import { render, staticRenderFns } from "./DetailEquipment.vue?vue&type=template&id=59f0c0ca&scoped=true&"
import script from "./DetailEquipment.vue?vue&type=script&lang=ts&"
export * from "./DetailEquipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f0c0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f0c0ca')) {
      api.createRecord('59f0c0ca', component.options)
    } else {
      api.reload('59f0c0ca', component.options)
    }
    module.hot.accept("./DetailEquipment.vue?vue&type=template&id=59f0c0ca&scoped=true&", function () {
      api.rerender('59f0c0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/DetailEquipment.vue"
export default component.exports